import { NavigateFunction } from 'react-router-dom';

import {
  APP_PAGES,
  INBOX_PREVIEW_FROM_VALUES,
  INBOX_PREVIEW_QUERY_PARAMS,
} from '../../routes/constants';

export function navigateToInboxOrDoBox(
  navigate: NavigateFunction,
  currentTab: string | null,
) {
  const url = new URL(window.location.href);
  const fromLabels =
    url.searchParams.get(INBOX_PREVIEW_QUERY_PARAMS.FROM) ===
    INBOX_PREVIEW_FROM_VALUES.LABELS;

  if (
    window.location.href.includes(APP_PAGES.DOBOX_PREVIEW.replace('/:id', ''))
  ) {
    navigate(APP_PAGES.DOBOX);
    return;
  }

  if (
    fromLabels ||
    window.location.href.includes(APP_PAGES.INBOX_LABELS.replace('/:id', ''))
  ) {
    navigate(APP_PAGES.INBOX_LABELS);
    return;
  }

  if (currentTab) {
    navigate(`${APP_PAGES.INBOX}?tab=${currentTab}`);
    return;
  }

  navigate(APP_PAGES.INBOX);
}
